import React from 'react';
import styles from './web-sub.module.scss';
import { Typography } from '@/ui-kit';
import WebApp from '@twa-dev/sdk';
import { Navigate } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { Trans } from 'react-i18next';

export const WebSub: React.FC = () => {
    if (WebApp.initData.length)
        return (
            <Navigate replace to={routesApp.subscription} />
        )

    return (
        <section className={styles.section}>
            <div className={styles.info}>
                <Typography
                    center
                    fontFamily="SFProDisplay"
                    fontWeight="bold"
                    className={styles.title}>
                    <Trans i18nKey="profile.web_sub_title" components={[
                        <a className={styles.link} href={'https://t.me/euphora_support'} />
                    ]} />
                </Typography>
            </div>
        </section>
    );
};
